import { STUB_FN_TRUE } from './stubs';

export type ToggleSate = 'opened' | 'closed';


export class Toggler {
   public state: ToggleSate = 'closed';
   private onOpen: () => boolean;
   private onClose: () => boolean;

   public get isOpened(): boolean { return this.state === 'opened'; }
   public get isClosed(): boolean { return this.state === 'closed'; }


   constructor(args?: {
      onOpen?: () => boolean;
      onClose?: () => boolean;
   }) {
      args = args || {};
      this.onOpen = args.onOpen || STUB_FN_TRUE;
      this.onClose = args.onClose || STUB_FN_TRUE;
   }


   public toggle() {
      switch(this.state) {
         case 'opened': this.close(); break;
         case 'closed': this.open(); break;
         default: console.error(`Unknown toggle state`);
      }
   }


   public open() {
      if (this.onOpen()) {
         this.state = 'opened';
      }
   }


   public close() {
      if (this.onClose()) { 
         this.state = 'closed';
      }
   }
}


